export enum DateRangeFilter {
  ThisMonth = 'THIS_MONTH',
  Last15Mins = 'LAST_15_MINS',
  Last30Mins = 'LAST_30_MINS',
  Last24Hours = 'LAST_24_HOURS',
  Last6Hours = 'LAST_6_HOURS',
  LastHour = 'LAST_HOUR',
  Today = 'TODAY',
  Last7Days = 'LAST_7_DAYS',
  Last30Days = 'LAST_30_DAYS',
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousWeek = 'PREVIOUS_WEEK',
  Last2Weeks = 'LAST_2_WEEKS',
  Last3Months = 'LAST_3_MONTHS',
  Last6Months = 'LAST_6_MONTHS',
  Last9Months = 'LAST_9_MONTHS',
  Last12Months = 'LAST_12_MONTHS',
}
